import React, { Component } from "react";
import { connect } from "react-redux";
import { reduxForm, Field } from "redux-form";
import { Form, FormGroup } from "react-bootstrap";
import { getUserData, getUserDataById } from "../../../../actions/user.actions";
import { Row, Col } from "react-bootstrap";
import Button from "../../../../components/common/button/Button";
import styles from "./Email.scss";
import Input from "../../../../components/common/input/Input";

import {
  required,
  requiredFirstName,
  requiredLastName,
  alphaSymbolicSpace,
  email
} from "../../../../utils/forms/validators";

export const emailValidation = msg => email(msg);
const alphaSymbolicSpaceValidation = msg => alphaSymbolicSpace(msg);

export const emailVal = emailValidation("Please enter a valid email address.");
const firstName = alphaSymbolicSpaceValidation(
  "Please enter a valid first name."
);
const lastName = alphaSymbolicSpaceValidation(
  "Please enter a valid last name."
);

class Email extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { memberId } = this.props;
    if (memberId) {
      this.props.getUserDataById(memberId);
    } else {
      this.props.getUserData();
    }
  }

  render() {
    const { submitting, valid } = this.props;
    return (
      <section className={styles.settings}>
        <div className={styles.content}>
          <h2 className={styles.title}>Basics</h2>

          <Form onSubmit={this.props.handleSubmit}>
            <div className={styles.form}>
              <FormGroup>
                <Row>
                  <Col md={12} xs={12}>
                    <Field
                      name="first_name"
                      type="text"
                      placeholder="First Name"
                      component={Input}
                      validate={[requiredFirstName, firstName]}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col md={12} xs={12}>
                    <Field
                      name="last_name"
                      type="text"
                      placeholder="Last Name"
                      component={Input}
                      validate={[requiredLastName, lastName]}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col md={12} xs={12}>
                    <Field
                      name="email"
                      type="text"
                      placeholder="Email Address"
                      component={Input}
                      validate={[required, emailVal]}
                    />
                  </Col>
                </Row>
              </FormGroup>

              <div className={styles.CTAContainer}>
                <Button
                  isPrimary
                  type="submit"
                  size={"large"}
                  noMarginBottom
                  label="Save Changes"
                  isDisabled={!valid || submitting}
                />
              </div>
            </div>
          </Form>
        </div>
      </section>
    );
  }
}

Email = reduxForm({
  form: "basicsForm",
  enableReinitialize: true
})(Email);

Email = connect(
  state => {
    return {
      user: state.user.data,
      initialValues: state.user.data,
      saving: state.user.loading
    };
  },
  dispatch => {
    return {
      getUserData: () => dispatch(getUserData()),
      getUserDataById: id => dispatch(getUserDataById(id))
    };
  }
)(Email);

export default Email;



// WEBPACK FOOTER //
// ./src/routes/candidate/profile/components/Email.js